/**
 * Utility functions for A/B testing experiments
 */

/**
 * Creates a consistent experiment assignment for the current session
 * @param {string} experimentId - Unique identifier for the experiment
 * @param {number} percentage - The percentage of users who should see the experimental variant (0-1)
 * @return {boolean} Whether the user is in the experimental group
 */
export const getExperimentVariant = (experimentId, percentage = 0.5) => {
  // Store decisions at module level to ensure consistency during session
  if (!window._experimentDecisions) {
    window._experimentDecisions = {};
  }

  // Only calculate once per session per experiment
  if (window._experimentDecisions[experimentId] === undefined) {
    window._experimentDecisions[experimentId] = Math.random() < percentage;
  }

  return window._experimentDecisions[experimentId];
};
